import React from "react";
import { motion } from "framer-motion";

import {
  aiActionMotion,
  utilityMotion,
  navigationMotion,
  destructiveMotion,
} from "../../motion/motions";

const motionMap = {
  ai: aiActionMotion,
  utility: utilityMotion,
  navigation: navigationMotion,
  destructive: destructiveMotion,
};

function MotionButton({
  children,
  variant = "utility",
  style = {},
  ...props
}) {
  const selectedMotion =
    motionMap[variant] || utilityMotion;

  return (
    <motion.button
      whileHover={{
        y: -2,
        scale: 1.01,
      }}
      whileTap={{
        scale: 0.985,
        y: 0,
      }}
      {...selectedMotion}
      style={style}
      {...props}
    >
      {children}
    </motion.button>
  );
}

export default MotionButton;